import appConfig from '../config.js';

const ACCESS_TOKEN_KEY = 'auth.access_token';
const ACCESS_EXPIRES_IN_KEY = 'auth.access_expires_in';
const ACCESS_EXPIRES_AT_KEY = 'auth.access_expires_at';
const REFRESH_TOKEN_KEY = 'auth.refresh_token';
const REFRESH_EXPIRES_IN_KEY = 'auth.refresh_expires_in';
const REFRESH_EXPIRES_AT_KEY = 'auth.refresh_expires_at';

function toExpiresIn(value) {
    if (value == null || value === '') {
        return null;
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}

function setExpires(storage, expiresInKey, expiresAtKey, expiresIn) {
    if (expiresIn != null) {
        storage.setItem(expiresInKey, String(expiresIn));
        storage.setItem(expiresAtKey, String(Date.now() + expiresIn * 1000));
    } else {
        storage.removeItem(expiresInKey);
        storage.removeItem(expiresAtKey);
    }
}

export function getPanelAccessToken() {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

function routerPathFromStoredRedirect(stored) {
    let path = stored || '/';
    if (path === '/app' || path.startsWith('/app/')) {
        path = path.slice(4) || '/';
    }
    if (!path.startsWith('/')) {
        path = '/' + path;
    }
    return path;
}

function clearOAuthQueryFromUrl() {
    const url = new URL(window.location.href);
    if (!url.search) {
        return;
    }
    url.search = '';
    window.history.replaceState({}, '', url.pathname + url.hash);
}

export function clearData() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(ACCESS_EXPIRES_IN_KEY);
    localStorage.removeItem(ACCESS_EXPIRES_AT_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(REFRESH_EXPIRES_IN_KEY);
    localStorage.removeItem(REFRESH_EXPIRES_AT_KEY);

    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(ACCESS_EXPIRES_IN_KEY);
    sessionStorage.removeItem(ACCESS_EXPIRES_AT_KEY);
}

export function setToken(data) {
    const accessToken = data.access_token;
    const refreshToken = data.refresh_token;
    const accessExpiresIn = toExpiresIn(data.access_expires_in ?? data.expires_in);
    const refreshExpiresIn = toExpiresIn(data.refresh_expires_in);

    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(ACCESS_EXPIRES_IN_KEY);
    localStorage.removeItem(ACCESS_EXPIRES_AT_KEY);

    if (accessToken) {
        sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
        setExpires(sessionStorage, ACCESS_EXPIRES_IN_KEY, ACCESS_EXPIRES_AT_KEY, accessExpiresIn);
    }

    if (refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
        setExpires(localStorage, REFRESH_EXPIRES_IN_KEY, REFRESH_EXPIRES_AT_KEY, refreshExpiresIn);
    }
}

function getState() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 32; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    localStorage.setItem('state', result);
    return result;
}

export function authorize() {
    const query = new URLSearchParams({
        response_type: 'code',
        grant_type: 'code',
        state: getState(),
        scope: appConfig.scope,
        client_id: appConfig.clientId,
        redirect_uri: appConfig.baseUrl,
    });
    localStorage.setItem('redirect', window.location.pathname);

    setTimeout(function () {
        window.location.href = appConfig.authUrl + 'api/v2/authorize?' + query.toString();
    }, 300);
}

export function redirectToIdLogin() {
    authorize();
}

function exchangeCode(oauthCode, onLogin, router, onFailure) {
    clearOAuthQueryFromUrl();

    const query = new URLSearchParams({
        grant_type: 'authorization_code',
        code: oauthCode,
        scope: appConfig.scope,
        client_id: appConfig.clientId,
        redirect_uri: appConfig.baseUrl,
    });

    fetch(appConfig.authUrl + 'api/v2/token', {
        method: 'POST',
        body: query.toString(),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    })
        .then(function (resp) {
            if (resp.status === 401) {
                clearData();
                authorize();
                return null;
            }

            if (resp.status !== 200) {
                resp.clone().text().then((t) => console.error('token error body:', resp.status, t));
                if (onFailure) {
                    onFailure(resp.status);
                }
                return null;
            }

            return resp.json();
        })
        .then(function (data) {
            if (!data) {
                return;
            }

            if (data.error) {
                console.warn('OAuth token error', data);
                if (data.error === 'unauthorized' || data.status === 401) {
                    clearData();
                    authorize();
                } else if (onFailure) {
                    onFailure(400);
                }
                return;
            }

            if (!data.access_token) {
                console.warn('OAuth token response without access_token');
                if (onFailure) {
                    onFailure(0);
                }
                return;
            }

            setToken(data);

            const redirect = localStorage.getItem('redirect');
            if (redirect && router) {
                router.replace(routerPathFromStoredRedirect(redirect));
                localStorage.removeItem('redirect');
            }

            if (onLogin) {
                onLogin();
            }
        })
        .catch(function (err) {
            console.error('token exchange failed', err);
            if (onFailure) {
                onFailure(0);
            }
        });
}

export function init(onLogin, router, onFailure) {
    const params = new URLSearchParams(document.location.search.substring(1));
    const oauthCode = params.get('code');

    if (oauthCode) {
        exchangeCode(oauthCode, onLogin, router, onFailure);
        return;
    }

    if (getPanelAccessToken()) {
        if (onLogin) {
            onLogin();
        }
        return;
    }

    clearData();
    authorize();
}
